import React from 'react';
import PT from 'prop-types';
import { useRenderFormFields } from 'Components/Admin/Form';

const AdminFormTab = ({ formItems, isBlocks }) => {
  const fields = useRenderFormFields(formItems, isBlocks);

  return (
    <>{fields}</>
  );
};

AdminFormTab.propTypes = {
  formItems: PT.array,
  initialValues: PT.object,
  onSubmit: PT.func,
  isBlocks: PT.bool,
  tabName: PT.string,
};

export default AdminFormTab;
